<template>
  <AppAside class="aside-for-terms">
    <template v-slot:title>
      <h1>Please review and agree to the following terms before submitting your reservation request.</h1>
    </template>
    <ul class="app-bullet-list">
      <li>
        Once your reservation is confirmed at check-in, normal ticketing procedures will apply,
        and you will be served as promptly as possible.
      </li>
      <li>
        No check-ins will be allowed more than 15 minutes prior to your reservation time. Customers arriving
        more than 15 minutes after their reservation time may not be admitted.
      </li>
      <li>
        Please have a copy of your reservation confirmation or your reservation number available at check-in.
        You will receive this confirmation and number on the next screen. You will be required to have proof
        of identification.
      </li>
    </ul>
    <div class="app-input-group" ref="agreementCheck">
      <div class="app-checker-group">
        <input type="checkbox" id="agreed" v-model="isAgreed">
        <label for="agreed">
          I have read, understand and agree to the above terms.
        </label>
      </div>
      <p class="error" hidden ref="noAgreement">You must accept the Terms and Conditions to continue.</p>
    </div>
  </AppAside>
</template>

<script setup>
import { ref, watch } from 'vue';
import AppAside from './AppAside.vue';

// Props 
const props = defineProps({
  verify: {
    type: Boolean,
    required: true,
  }
});

// Emits
const emit = defineEmits(['doValidated', 'doResetVerify']);

const isAgreed = ref(false);
const agreementCheck = ref(null);
const noAgreement = ref(null);

// Methods
const toggleAgreementCheck = () => {
  if (isAgreed.value) {
    noAgreement.value.setAttribute('hidden', 'hidden');
    agreementCheck.value.classList.remove('app-invalid-group');
  } else {
    noAgreement.value.removeAttribute('hidden');
    agreementCheck.value.classList.add('app-invalid-group');
  }
}

// Watcher 
watch(isAgreed, () => {
  toggleAgreementCheck();
});

watch(() => props.verify, (newVal) => {
  if (newVal) {
    toggleAgreementCheck();
    if (isAgreed.value) {
      emit('doValidated');
    } else {
      emit('doResetVerify');
    }
  }
});
</script>


<style scoped lang="scss">
.app-notice {
  max-width: unset;
}
.aside-for-terms {
  flex-grow: 1;
  margin-bottom: 2em;
  .app-input-group {
    margin-top: 1em;
    margin-left: 1.25em;
  }
}
</style>
